import React from 'react';
import { findByText } from 'Common/Utils';
import { IntroNotice } from './IntroNotice';
import { HookShotChaperone, ClickGesture } from 'Snippets/Redundancy';
export const SubmittingForm = [
	{
		message: <IntroNotice message={2} />,
		find: 'a[data-chaperone-trigger]',
	},
	{
		message: (
			<>Beforehand, I want to emphasize on how to use arrayed field name...</>
		),
		find(target) {
			return findByText(target, 'span:languages')[0];
		},
	},
	{
		message: (
			<>
				It is use to determine that the text/checkbox field is <b>multiple</b>{' '}
				in the submit. although you can use the normal one. but the disadvantage
				is that the <b>FormEvent</b> doesn't recognized it as a <b>multiple</b>{' '}
				at first. until it is more than 1 which will cause a confusion/problem
				in the back-end. on the other hand the arrayed name will be
				automatically recognized by the FormEvent as multiple...
			</>
		),
		find(target) {
			return findByText(target, 'span:languages')[1];
		},
	},
	{
		message: (
			<>
				If you ever step a foot on arrayed field name. You can always use this
				method below to make an alias variable or make a formState single
				fetch...
			</>
		),
		find(target) {
			return findByText(target, 'span:languages')[2];
		},
	},
	{
		message: (
			<>
				And now, We can use <b>formSubmit</b>. It is use to handle the submition
				of the form fields...
			</>
		),
		find(target) {
			return findByText(target, 'span:formSubmit')[0];
		},
	},
	{
		message: (
			<>
				This is how we use it. We passed a <b>function</b> inside{' '}
				<b>formSubmit</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:formSubmit')[2];
		},
	},
	{
		message: (
			<>
				The <b>function</b> we passed must have an argument like below. because
				this argument passed to our <b>function</b> is the instance of
				FormEvent...
			</>
		),
		find(target) {
			return findByText(target, 'span:event')[0];
		},
	},
	{
		message: <>You can check the FormEvent Methods here for more info...</>,
		find() {
			return document.querySelector('.scroll-nav a[href="#useform"]');
		},
	},
	{
		message: (
			<>
				<b>FormEvent</b> method <b>isReady</b> is use to determine whether the
				form fields is ready or no invalidations. Inside this section of
				statement were you put your sever-side request like ajax or something...
			</>
		),
		find(target) {
			return findByText(target, 'span:isReady')[0];
		},
	},
	{
		message: (
			<>
				There are many ways of getting the form data from <b>FormEvent</b>. it
				depends on your content-type. Method <b>param</b> is use for url encoded
				content-type...
			</>
		),
		find(target) {
			return findByText(target, 'span:param')[0];
		},
	},
	{
		message: (
			<>
				After you make a request, don't forget to use <b>FormEvent</b> method{' '}
				<b>reset</b>. To reset both the form and controllable fields...
			</>
		),
		find(target) {
			return findByText(target, 'span:reset')[0];
		},
	},
	{
		message: (
			<>
				On the other side of the statement. You can use <b>FormEvent</b> method{' '}
				<b>locateFailed</b> to locate the failed fields whenever it is out of
				the view port...
			</>
		),
		find(target) {
			return findByText(target, 'span:locateFailed')[0];
		},
	},
	{
		message: (
			<>
				Finally, We assign it on <b>form onSubmit</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:formSubmit')[3];
		},
		...HookShotChaperone({
			target: (target) => findByText(target, 'span:formSubmit')[3],
			from: (target) => findByText(target, 'span:formSubmit')[3],
			to: (target) => findByText(target, 'span:formSubmit')[1],
		}),
	},
	{
		message: <>That was eazy! Let's try out the result!</>,
		find: 'select',
		isDoneOnClick: true,
		gesture: <ClickGesture />,
		background: {
			backdropStyle: { opacity: 1 },
			highlightStyle: { backgroundColor: 'rgba(255,255,255, 1)' },
			gestureStyle: { zIndex: null }
		},
	},
];

// note
// those fields who are not registered from the schema are excluded from -
// FormEvent method json, param and paramArray. if you want to involve the -
// unregistered field you can always use method formData that will return FormData instance...
